export default __webpack_public_path__ + "static/media/D-dried Up.15968f2b.png";